module.exports = __webpack_public_path__ + "7e02d72889f422df71ea55dc663a44e4.svg";